import { buildBetBuilderGroupTab } from '@/utils/betBuilderGroupTab';

/**
 * Live bet builder in the live event detail views (classic, american, terminal):
 * the "Combo" tab next to the first market group, shown only when the platform
 * has the live bet builder (skin enableLiveBetBuilder on the DataSavage engine)
 * and rocky-api confirmed it for this event (sport priced live, event matched).
 *
 * The host view keeps the current event in `this.object` and renders
 * `withLiveBetBuilderGroup(groups)`; selecting the tab loads the bet builder
 * markets through `detailLive/fetchBetBuilderMarketsLive`.
 */
export default {
    computed: {
        liveBetBuilderGroup() {
            if (!this.$store.getters['settings/getEnableLiveBetBuilder']) return null;
            const eventId = this.object?.event?.id;
            if (this.$store.getters['betbuilder/isLiveEventAvailable'](eventId) !== true) return null;
            return buildBetBuilderGroupTab(this.$store, this.$i18n.locale);
        },

        // Odds grid locked while the cart works (bet builder quote, placement), as in the
        // prematch detail: a second click on the same event would start a concurrent quote,
        // and the last answer would set its combined price on the whole group.
        liveBetBuilderCartLocked() {
            return this.$store.getters['settings/getEnableLiveBetBuilder'] === true
                && this.$store.getters['cart/getLoading'] === true;
        },
    },

    watch: {
        'object.event.id': {
            immediate: true,
            handler(eventId) {
                if (eventId && this.$store.getters['settings/getEnableLiveBetBuilder']) {
                    this.$store.dispatch('betbuilder/checkLiveEventAvailability', eventId);
                }
            },
        },
    },

    methods: {
        withLiveBetBuilderGroup(groups) {
            const tab = this.liveBetBuilderGroup;
            if (!tab) return groups;
            return groups.length > 0 ? [groups[0], tab, ...groups.slice(1)] : [tab];
        },
    },
};
